import React from "react";
import ReactDOM from "react-dom";
import App from "./components";
import "./static/css/global.css";
import "./static/css/table.css";
import "./static/css/fonts.css";
import reportWebVitals from "./reportWebVitals";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Reload once on ChunkLoadError so stale cached index.html picks up the new build
const handleChunkError = () => {
  if (!sessionStorage.getItem("chunk-reload")) {
    sessionStorage.setItem("chunk-reload", "1");
    window.location.reload();
  }
};

window.addEventListener("error", (e) => {
  if (e?.message?.includes("Loading chunk") || e?.message?.includes("ChunkLoadError")) {
    handleChunkError();
  }
});

window.addEventListener("unhandledrejection", (e) => {
  const msg = e?.reason?.message || e?.reason?.name || "";
  if (msg.includes("Loading chunk") || msg.includes("ChunkLoadError")) {
    handleChunkError();
  }
});

ReactDOM.render(
	<React.StrictMode>
		<App />
		<ToastContainer
			position="bottom-center"
			autoClose={false}
			closeOnClick={false}
		/>
	</React.StrictMode>,
	document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(//))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
